<template>
    <v-container fluid class="pa-0" style="height: 100vh; max-height: 100%;">
        <v-layout row fill-height wrap>
            <v-flex sm12 md4 id="form">
                <v-layout row justify-end>
                    <v-flex class="btn-language" sm12 md6>
                        <v-btn flat color="secondary" @click="changeLanguage()">
                            <v-icon size="25px" dark>language</v-icon>
                            <span class="appended-element button-content">
                                {{ this.$t('message.toggleLanguageText') }}
                            </span>
                        </v-btn>
                    </v-flex>
                </v-layout>
                <img src="@/assets/logo.png" class="login-logo" alt="Whirlpool" height="34">
                <div id="form-title">
                    <h3 id="form-header-title" class="font-weight-bold">
                        {{ this.$t('message.loginWelcomeText') }}
                    </h3>
                    <h3 id="form-middle-title" class="font-weight-light">
                        <div class="underline">
                            {{ this.$t('message.loginSupplierText') }}
                        </div>
                    </h3>
                </div>

                <div id="login-form" v-if="!showRecoverPassword && !token">
                    <h3 id="login-title" class="font-weight-light form-subtitle">
                        {{ this.$t('message.loginTitle') }}
                    </h3>
                    <div class="text-xs-center">
                        <v-text-field class="lance" ref="rfc" autofocus v-bind:label="$t('message.formSupplierCode')"
                            v-model="model.supplierCode">
                        </v-text-field>
                        <v-text-field class="lance" type="password" v-bind:label="$t('message.formPassword')"
                            v-model="model.password" @keyup.enter.native="login()">
                        </v-text-field>
                        <a @click="showRecoverPassword = true">
                            {{ this.$t('message.loginRecoveryLink') }}
                        </a>
                        <v-layout class="login-button-container" row wrap>
                            <v-flex sm12 md6 class="pr-2">
                                <v-btn solo color="#1D7EC3" outline @click="goTo('/signup')">
                                    <span class="button-content">
                                        {{ this.$t('message.loginSignup') }}
                                    </span>
                                </v-btn>
                            </v-flex>
                            <v-flex sm12 md6 class="pl-2">
                                <v-btn solo color="primary" @click="login()">
                                    <span class="button-content">
                                        {{ this.$t('message.loginButtonText') }}
                                    </span>
                                    <v-icon class="appended-element" size="25px" dark>input</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </div>
                    <div class="subtext mb-4">
                        {{ this.$t('message.loginRecoverText') }}
                        <strong>
                            {{ this.$t('message.loginRecoverStrongText') }}
                        </strong>
                    </div>
                    <div id="bottom-note" class="subtext mb-4">
                        <strong>
                            {{ this.$t('message.loginHelpText') }}
                        </strong>
                    </div>
                </div>

                <div id="send-recover-password-form" v-if="showRecoverPassword">
                    <h3 class="font-weight-light mb-2">
                        {{ this.$t('message.passwordRecoveryFormTitle') }}
                    </h3>
                    <div class="subtext mb-5">
                        {{ this.$t('message.passwordRecoveryFormSubtitle') }}
                    </div>
                    <div class="stretch text-xs-center">
                        <v-form ref="recoveryForm" v-model="valid" action="javascript:void(0)">
                            <v-text-field class="lance" type="text"
                                :label="this.$t('message.passwordRecoveryFormEmailLabel')" v-model="email" :rules="[
                                    v => !!v || this.$t('message.formRequiredField'),
                                    v => /.+@.+/.test(v) || this.$t('message.passwordRecoveryFormInvalidEmail')
                                ]" @keyup.enter.native="sendRecoveryEmail()">
                                <template slot="append">
                                    <v-btn id="sendRecoveryEmailBtn" class="btn-login" color="primary" depressed
                                        min-width="75px" :loading="loading" @click="sendRecoveryEmail()">
                                        <v-icon size="40px" dark>input</v-icon>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </v-form>
                        <a @click="showRecoverPassword = false">
                            {{ this.$t("message.passwordRecoveryFormReturnLink") }}
                        </a>
                    </div>
                </div>

                <div id="recover-password-form" v-if="token">
                    <h3 class="font-weight-light mb-2">{{ this.$t("message.passwordRecoveryTitle") }}</h3>
                    <div class="subtext mb-5">{{ this.$t("message.passwordRecoverySubtitle") }}</div>
                    <div class="stretch text-xs-center">
                        <v-form ref="passwordReset" v-model="valid" action="javascript:void(0)">
                            <v-text-field class="lance" v-model="model.newPassword"
                                :label="this.$t('message.passwordRecoveryNewPasswordLabel')" type="password"
                                :rules="[v => !!v || this.$t('message.formRequiredField')]">
                            </v-text-field>
                            <v-text-field class="lance" v-model="model.confirmPassword"
                                :label="this.$t('message.passwordRecoveryConfirmPasswordLabel')" type="password" :rules="[
                                    v => !!v || this.$t('message.formRequiredField'),
                                    v => v === model.newPassword || this.$t('message.passwordRecoveryPasswordsDoNotMatch')
                                ]" @keyup.enter.native="resetPassword()">
                                <template slot="append">
                                    <div class="btn-login" @click="resetPassword()">
                                        <v-icon size="40px" dark>input</v-icon>
                                    </div>
                                </template>
                            </v-text-field>
                        </v-form>
                        <br>
                    </div>
                </div>
            </v-flex>

            <v-flex sm12 md8 id="landing">
                <div id="version" v-if="version">
                    v{{ version }}
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { events } from '../main';
import { i18n } from '../utils/locales/default';

export default {
    name: 'login',
    data() {
        return {
            model: {
                supplierCode: '',
                password: ''
            },
            valid: false,
            version: null,
            email: "",
            token: null,
            showRecoverPassword: false,
            loading: false,
        }
    },
    methods: {
        goTo(url) {
            this.$router.push(url);
        },
        login() {
            if (!this.model.supplierCode || !this.model.password) {
                this.snackbar(this.$t('message.loginEmptyFields'));
                return;
            }
            this.model.userId = localStorage.getItem("userId");
            this.$http.post('SupplierLogin', this.model)
                .then(response => {
                    localStorage.setItem("supplierCode", response.body.supplierCode);
                    localStorage.setItem("supplierRFC", response.body.supplierRFC);
                    localStorage.setItem("supplierToken", response.body.token);
                    localStorage.setItem("supplierCredentials", response.body.credentials);
                    const redirectUrl = this.$route.query.redirect;
                    redirectUrl ? this.$router.push(redirectUrl) : this.$router.push('/');
                }, error => {
                    this.snackbar(this.$t('message.loginWrongCredentials'));
                    this.model = {
                        rfc: '',
                        password: ''
                    }
                    this.$refs.rfc.focus();
                });
        },
        changeLanguage() {
            if (i18n.locale == "en") {
                i18n.locale = "es";
            } else {
                i18n.locale = "en";
            }

            if (this.showRecoverPassword) {
                for (let input of this.$refs.recoveryForm.inputs) {
                    if (input.hasMessages)
                        input.validate(true);
                    else if (input.hasError)
                        input.validate(false);
                }
            }
            if (this.token) {
                for (let input of this.$refs.passwordReset.inputs) {
                    if (input.hasMessages)
                        input.validate(true)
                    else if (input.hasError)
                        input.validate(false);
                }
            }
        },
        sendRecoveryEmail() {
            if (!this.valid) {
                this.snackbar(this.$t("message.passwordRecoveryFormInvalidEmail"));
                return;
            }
            this.loading = true;
            this.$http.post("SupplierLogin/recoverpassword", { email: this.email }).then(
                result => {
                    this.snackbar(this.$t("message.passwordRecoveryFormSuccess"));
                    this.email = "";
                    this.showRecoverPassword = false;
                },
                error => {
                    this.snackbar(this.$t("message.passwordRecoveryFormFail"));
                }
            ).finally(() => {
                this.loading = false;
            });
        },
        /*************************       Recover Password Funcions       *************************/
        validateToken() {
            this.$http.post(`SupplierLogin/validatetoken/${this.token}`).then(response => { }).catch(error => {
                this.snackbar(this.$t("message.passwordRecoveryInvalidToken"));
                this.$router.push("/login");
                this.token = null;
            });
        },
        resetPassword() {
            if (!this.valid) {
                this.snackbar(this.$t("message.passwordRecoveryInvalidPassword"));
                return;
            }
            this.$http.put("SupplierLogin/recoverpassword/" + this.token, { newPassword: this.model.newPassword })
                .then(response => {
                    this.snackbar(this.$t("message.passwordRecoverySuccess"))
                    this.$router.push("/");
                }).catch(error => {
                    let msg = this.$t("message.passwordRecoveryFail")
                    if (error.body.code == 4) {
                        msg = this.$t("message.passwordRecoveryFailCode4");
                    }
                    this.snackbar(msg);
                });
        },
        snackbar(message) {
            events.$emit('snackbar', message);
        }
    },
    mounted() {
        //FIXME: This is only for pre-prod/prod environments
        const allowDirectLogin = process.env.VUE_APP_ALLOW_DIRECT_LOGIN === 'true';
        if (process.env.NODE_ENV != 'development' && !allowDirectLogin) {
            location.href = process.env.VUE_APP_URLEXTERNAL;
        }

        this.$http.get("app/version").then(
            result => {
                this.version = result.body.version;
            },
            error => {
                this.snackbar(this.$t('message.versionRetrievalFail'));
            }
        );
        this.token = this.$route.params.token;
        if (this.token) {
            this.title = "Recuperar Contraseña";
            this.validateToken();
        }
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus()
            }
        }
    }
}
</script>

<style scoped>
#form {
    padding-left: 55px;
    padding-right: 55px;
    background-color: #f2f2f2;
    color: #474747;
    z-index: 1;
}

#form .login-logo {
    margin-top: 10px;
    width: 278px;
    /*48%;*/
    height: auto;
}

#form #form-title {
    margin-top: 22px;
    margin-bottom: 90px;
    margin-right: 110px;
    max-width: 390px;
}

#form #form-header-title {
    font-size: 32px;
    line-height: 30px;
}

#form #form-middle-title {
    font-size: 55px;
    line-height: 60px;
}

#form #login-title {
    margin-bottom: 10px;
}

#form #bottom-note {
    color: var(--v-primary-base);
}

#form .form-subtitle {
    font-size: 21px;
    line-height: 40px;
}

#form .underline {
    display: inline-block;
    border-bottom: 4px solid var(--v-primary-base);
    padding-bottom: 0;
    line-height: 120%
}

#form .subtext {
    font-size: 14px;
    padding-right: 15%;
    line-height: 18px;
}

#form .v-text-field>>>.v-input__slot {
    height: 60px;
    border-radius: 100px;
    margin-bottom: 28px;
    padding-left: 80px;
    padding-right: 0;
}

#form .login-button-container {
    margin-bottom: 48px;
}

#form .login-button-container .flex>button.v-btn:not(.v-btn--floating) {
    margin: 0;
    width: 100% !important;
    height: 60px !important;
    text-transform: none;
    border-radius: 100px;
    color: white;
    font-size: 16px;
}

#form .button-content {
    white-space: normal;
}

#form .appended-element {
    padding-left: 8px !important;
}

#form a {
    display: inline-block;
    margin-bottom: 60px;
}

.btn-login,
#sendRecoveryEmailBtn {
    margin: 0;
    padding-left: 0;
    height: 60px;
    width: 75px;
    min-width: 0;
    padding-right: 10px;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
    background-color: var(--v-primary-base);
    color: white;
    display: flex;
    justify-content: center;
    cursor: pointer;
}

.btn-language {
    margin-top: 20px;
    text-align: right;
}

.btn-language .v-btn {
    margin-right: 0;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 16px;
    text-transform: none;
}

#landing {
    background-image: url("../assets/supplierLanding.png");
    background-size: cover;
    resize: both;
    z-index: 0;

}

#version {
    position: absolute;
    bottom: 4px;
    right: 10px;
}

@media screen and (max-width: 959px) {
    #form {
        padding-left: 30px;
        padding-right: 30px;
    }

    #form #form-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }

    #form .stretch {
        width: 100%;
    }
}
</style>
